import { Controller } from '@hotwired/stimulus';

// Open/closed state of a single item. The header is the click surface; the
// root class, toggle button and body reflect the state. An item with an editor or an edit
// link has no body to open, so its header presses the trigger instead. Dispatches
// `accordion-item-component:open|close` so the parent accordion can coordinate.
export default class extends Controller {
  static targets = ['toggle', 'body', 'trigger'];

  static values = {
    open: Boolean
  };

  toggle(event) {
    if (event.target.closest('a, [data-accordion-component-ignore]')) return;

    // The toggle button has no action of its own — it rides on the header's. Any other
    // control in the header is a custom edit action, which must not also open the body.
    const button = event.target.closest('button');
    if (button && !(this.hasToggleTarget && button === this.toggleTarget)) return;

    this.openValue = !this.openValue;
  }

  // Any control in the header is its own action, and the trigger is one of them.
  activate(event) {
    if (event.target.closest('a, button, [data-accordion-component-ignore]')) return;

    if (this.hasTriggerTarget) this.triggerTarget.click();
  }

  open() {
    this.openValue = true;
  }

  close() {
    this.openValue = false;
  }

  openValueChanged(open, previous) {
    this.element.classList.toggle('ui-accordion-item--open', open);
    if (this.hasToggleTarget) this.toggleTarget.setAttribute('aria-expanded', String(open));
    if (this.hasBodyTarget) this.bodyTarget.hidden = !open;

    // First call mirrors the server-rendered state; nothing changed yet.
    if (previous === undefined) return;

    this.dispatch(open ? 'open' : 'close');
  }
}
